import React from 'react';
import NarrowStageWithLogo from 'commonComponents/Stages/NarrowStageWithLogo/NarrowStageWithLogo';
import SuccessMessage from 'commonComponents/forms/SuccessMessageWithExperts/SuccessMessageWithExperts';
import InfoBar from 'commonComponents/sections/FormBoxSection/InfoBar/InfoBar';
import FormBoxSection from 'commonComponents/sections/FormBoxSection/FormBoxSection';
import { mergeObjects } from 'lib/utils/dataUtils';
import { ClubDealsLogo } from './images';
import styles from '../pages.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const ClubDealsFormPage = ({
  banner,
  common,
  unique,
  token,
  user,
  sitekey
}) => {
  const form = mergeObjects(common, unique);

  const { sidebar, thankyou, experts } = form;

  const bannerProps = {
    ...banner,
    logo: ClubDealsLogo,
    pageName: 'clubDeals'
  };

  const leadHiddenFields = [
    { name: 'sign_up_as', value: 'candidate' },
    { name: 'custom_lead_source', value: 'Club Deals' },
    { name: 'create_so', value: false }
  ];

  const expertsProps = [...experts];
  expertsProps.forEach(expert => expert.isPrimary = true);

  const contactFormProps = {
    form,
    token,
    sitekey,
    user,
    orderOfFields: ['first_name', 'last_name', 'company_name', 'email', 'phone'],
    hiddenFields: leadHiddenFields,
    successBlock: () => <SuccessMessage { ...thankyou } experts={ experts } />,
    sideBar: isShow => {
      return isShow &&
        <InfoBar { ...sidebar } experts={ expertsProps } />;
    }
  };

  return (
    <div className={ styles.Page }>
      <NarrowStageWithLogo { ...bannerProps } />
      <FormBoxSection { ...contactFormProps } />
    </div>
  );
};
 
export default ClubDealsFormPage;
